import React, { useId, useState } from 'react'
import { ChevronDown, ChevronRight, Copy } from 'lucide-react'
import { copyText, fmtJson } from './model'

// A JSON value, already masked by the backend, with a Copy button. Shown as
// is: this screen never adds to or reformats what it was sent.
export function JsonBlock({ value, label = 'JSON' }) {
  const text = fmtJson(value)
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button type="button" className="btn btn-ghost btn-sm" onClick={() => copyText(text, `${label} copied`)}>
          <Copy size={13} aria-hidden="true" /> Copy
        </button>
      </div>
      <pre className="li-json li-mono" aria-label={label}>{text}</pre>
    </div>
  )
}

// A collapsed JSON block behind a toggle. Closed by default: payloads are
// long and most visits only need the summary around them.
export default function JsonViewer({ value, label = 'JSON', defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen)
  const id = useId()
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <button type="button" className="li-toggle" aria-expanded={open} aria-controls={id} onClick={() => setOpen((o) => !o)}>
        {open ? <ChevronDown size={14} aria-hidden="true" /> : <ChevronRight size={14} aria-hidden="true" />}
        {open ? `Hide ${label}` : `Show ${label}`}
      </button>
      {open && <div id={id}><JsonBlock value={value} label={label} /></div>}
    </div>
  )
}
